export function canUserAccessProductType(allowedProducts: string[], productType: string) {
    return allowedProducts && allowedProducts.indexOf(productType) > -1;
}
